<template>
  <div class="product">
    <div class="product__container">
      <div class="product__showroom">
        <div class="product__showroom__slide">
          <splide :options="{rewind: true,}">
            <splide-slide v-for="(item, index) in theImgList"
            :key="index">
              <img :src="item">
            </splide-slide>
          </splide>
        </div>
        <div class="product__showroom__lightbox">
          <div class="mainDiv">
            <img class="mainDiv__img" :src="lightboxMain" alt="">
          </div>
          <ul class="imgList">
            <li class="imgList__item"
            v-for="(image, i) in theImgList"
            :key="i">
              <img class="image"
              :src="image"
              @click="lightboxIndex = i"
              @mouseover='change_lightboxMain(i)'>
            </li>
          </ul>
          <vue-gallery-slideshow
          :images="theImgList"
          :index="lightboxIndex"
          @close="lightboxIndex = null">
          </vue-gallery-slideshow>
        </div>
      </div>
      <div class="product__main">
        <div class="product__header">
          <p class="product__title">{{theProduct.title}}</p>
          <div class="product__id">{{theProduct.id}}</div>
        </div>
        <div class="product__content" v-html="theProduct.content"></div>
        <div class="product__price">
          NT${{theProduct.price}}
        </div>
        <div class="product__purchase">
          <div class="product__quantity">
            <span class="product__quantity__text">數量: </span>
            <b-form-spinbutton v-model="newCartProduct.quantity"
            min="1" max="100"></b-form-spinbutton>
          </div>
          <div class="product__funcBlock">
            <div class="product__funcBlock__btns">
              <a href="#" class="myBtn myBtn--secondary"
              @click.prevent='add_cart'>加入購物車</a>
              <a href="#" class="myBtn myBtn--primary"
              @click="go_checkout">直接購買</a>
            </div>
            <p class="product__remark">
              台灣本島地區全站商品免運配送
            </p>
          </div>
        </div>
        <div class="product__favorite">
            <label class="favorite">
              <input type="checkbox" class="favorite__input" v-model='isFavorite'
              @change='toggle_favorite($event.target.checked)'>
              <span class="favorite__span favorite--true"
              v-if='isFavorite'>
                <img src="@/assets/icon/gold_heart_icon.png">
                <span class="favorite__text">已加入喜好項目</span>
              </span>
              <span class="favorite__span favorite--false"
              v-if='!isFavorite'>
                <img src="@/assets/icon/gold_heart_empty_icon.png">
                <span class="favorite__text">加入喜好項目</span>
              </span>
            </label>
        </div>
        <div class="product__description">
          <b-tabs>
            <b-tab active
            v-for="(item, index) in theProduct.description"
            :key="index"
            :title='item.title'>
              <div class="product__description__body" v-html="item.text"></div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <div class="product__container">
      <div class="product__relatedProducts">
        <div class="product__relatedProducts__header">
          <p>相關商品</p>
        </div>
        <product-list
        :list='relatedList'
        :category='theCategory'></product-list>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import productList from '@/components/ProductList.vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import VueGallerySlideshow from 'vue-gallery-slideshow';
/* eslint-disable */
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
/* eslint-enable */

export default {
  watch: {
    theProduct() {
      this.initialize();
    },
  },
  components: {
    productList,
    Splide,
    SplideSlide,
    VueGallerySlideshow,
  },
  computed: {
    cart() {
      let cart;
      const getCart = () => {
        this.$bus.$on('get_cart', (cartObj) => {
          cart = cartObj;
        });
        this.$bus.$emit('call_cart');
      };
      getCart();
      return cart;
    },
    allProducts() {
      let allProducts;
      const getAllProducts = () => {
        this.$bus.$on('son_get_data', (data) => {
          allProducts = data.products;
          allProducts = JSON.parse(JSON.stringify(allProducts));
        });
        this.$bus.$emit('son_call_data');
      };
      getAllProducts();
      return allProducts;
    },
    theProduct() {
      const theProductId = this.$route.params.id;
      let theProduct = {};
      theProduct = this.allProducts.find((item) => item.id === theProductId);
      return theProduct;
    },
    theCategory() {
      let thisCategoryObj;
      if (this.$route.params.category === 'all') {
        thisCategoryObj = {
          chinese: '全部',
          english: 'all',
        };
      } else {
        thisCategoryObj = this.theProduct.category
          .find((item) => item.english === this.$route.params.category);
      }
      return thisCategoryObj;
    },
    theImgList() {
      let list = Object.values(this.theProduct.images);
      list = list.flat(2);
      return list;
    },
    user() {
      let user;
      this.$bus.$on('son_get_data', (data) => {
        user = data.member;
      });
      this.$bus.$emit('son_call_data');
      return user;
    },
    relatedList() {
      let relatedList;
      const isAll = () => {
        const theProductIndex = this.allProducts.findIndex((item) => item === this.theProduct);
        relatedList = this.allProducts;
        relatedList.splice(theProductIndex, 1);
      };
      const getCategoryObj = () => {
        const theCategory = this.theProduct.category
          .find((item) => item.english === this.$route.params.category);
        relatedList = this.allProducts
          .filter((item) => item.category
            .find((item2) => JSON.stringify(item2) === JSON.stringify(theCategory)) !== undefined);
        const theProductIndex = relatedList.findIndex((item) => item === this.theProduct);
        relatedList.splice(theProductIndex, 1);
      };
      if (this.$route.params.category === 'all') {
        isAll();
      } else {
        getCategoryObj();
      }
      relatedList = JSON.parse(JSON.stringify(relatedList));
      if (relatedList.length > 4) {
        relatedList.length = 4;
      }
      return relatedList;
    },
  },
  data() {
    return {
      newCartProduct: {
        img: '',
        title: '',
        id: '',
        price: 0,
        quantity: 1,
      },
      isFavorite: false,
      lightboxIndex: null,
      lightboxMain: '',
    };
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    initialize() {
      // set newCartProduct
      this.newCartProduct.img = this.theProduct.images.main;
      this.newCartProduct.title = this.theProduct.title;
      this.newCartProduct.id = this.theProduct.id;
      this.newCartProduct.price = this.theProduct.price;

      this.isFavorite = this.user.favorites.includes(this.theProduct.id);

      /* eslint-disable */
      this.lightboxMain = this.theImgList[0];
      /* eslint-enable */
    },
    toggle_favorite(isChecked) {
      if (this.user.id === '') {
        this.isFavorite = false;
        alert('請登入會員以加入喜好項目');
      } else {
        this.emit_favorite(isChecked);
      }
    },
    emit_favorite(boolean) {
      this.$bus.$emit('edit_favorite', this.theProduct.id, boolean);
    },
    change_lightboxMain(index) {
      /* eslint-disable */
      this.lightboxMain = this.theImgList[index];
      /* eslint-enable */
    },
    add_cart() {
      this.$bus.$emit('add_to_cart', this.newCartProduct);
      this.$bus.$emit('toggleCart', true);
      this.newCartProduct.quantity = 1;
    },
    go_checkout() {
      this.$bus.$emit('add_to_cart', this.newCartProduct);
      this.newCartProduct.quantity = 1;
      this.go_page('/front/checkout');
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    const imgSquare = () => {
      const img = $('.mainDiv__img');
      const imgWidth = img.innerWidth();
      img.innerHeight(imgWidth);
    };
    imgSquare();
    $(window).resize(() => {
      imgSquare();
    });
  },
};
</script>
